import { render, staticRenderFns } from "./TsAlertChart.vue?vue&type=template&id=58efec82&scoped=true&"
import script from "./TsAlertChart.vue?vue&type=script&lang=js&"
export * from "./TsAlertChart.vue?vue&type=script&lang=js&"
import style0 from "./TsAlertChart.vue?vue&type=style&index=0&id=58efec82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58efec82",
  null
  
)

export default component.exports